import { render, staticRenderFns } from "./TemplateProjeactFill.vue?vue&type=template&id=35cbae85&scoped=true"
import script from "./TemplateProjeactFill.vue?vue&type=script&lang=js"
export * from "./TemplateProjeactFill.vue?vue&type=script&lang=js"
import style0 from "./TemplateProjeactFill.vue?vue&type=style&index=0&id=35cbae85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbae85",
  null
  
)

export default component.exports